<template>
  <div v-if="current">
    <div class="row">
      <div class="col-md-12">
        <v-btn color="blue-grey white--text" @click="sync()" class="mr-2">Sincronizar</v-btn>
        <v-btn color="primary" @click="list(1)" class="ma-2">Aguardando</v-btn>
        <v-btn color="success" @click="list(2)" class="ma-2">Positiva</v-btn>
        <v-btn color="error" @click="list(3)" class="ma-2">Negativa</v-btn>
        <v-btn color="warning" @click="list(4)" class="ma-2">Vistoria</v-btn>
        <v-btn color="secondary" @click="list(5)" class="ma-2">Rejeitada</v-btn>
        <v-btn color="default" @click="openSearch()" class="ma-2">Procurar</v-btn>
      </div>
    </div>

    <v-alert
      dense
      v-if="showFiltros"
      color="grey"
      border="left"
      elevation="2"
      colored-border
    >
      <div class="row">
        <div class="col-md-3">
          <v-select
            label="Operadora"
            v-model="filtros.operadora"
            :items="operadoras"
            outlined
            dense
          ></v-select>
        </div>
        <div class="col-md-3">
          <v-select
            label="Status"
            v-model="filtros.status"
            :items="status"
            outlined
            dense
          ></v-select>
        </div>
        <div class="col-md-2">
          <v-menu
            v-model="menu_de"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedDe"
                label="De"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filtros.de"
              @input="deAlterada()"
              locale="pt-br"
            ></v-date-picker>
          </v-menu>
        </div>
        <div class="col-md-2">
          <v-menu
            v-model="menu_ate"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-y
            min-width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                v-model="computedAte"
                label="Até"
                readonly
                v-bind="attrs"
                v-on="on"
                outlined
                dense
              ></v-text-field>
            </template>
            <v-date-picker
              v-model="filtros.ate"
              @input="ateAlterada()"
              locale="pt-br"
            ></v-date-picker>
          </v-menu>
        </div>
        <div class="col-md-2">
          <v-btn small fab dark color="grey" @click="search()"><v-icon>mdi-magnify</v-icon></v-btn>
        </div>
      </div>
    </v-alert>

    <v-simple-table>
      <thead>
        <tr>
          <th>Operadora</th>
          <th>Origem</th>
          <th>Cliente</th>
          <th>Endereço</th>
          <th>Cidade</th>
          <th>Entrada</th>
          <th>Status</th>
          <th>Ações</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in current" :key="item.id">
          <td>{{ item.operadora | formatOperadora }}</td>
          <td>{{ item.origem | formatOrigem }}</td>
          <td>{{ item.cliente }}</td>
          <td>{{ item.endereco }}</td>
          <td>{{ item.cidade }}</td>
          <td>{{ item.inicio | formatDate }}</td>
          <td>
            <v-chip :color="colorStatus(item)" text-color="white" small>{{ item | formatStatus }}</v-chip>
          </td>
          <td>
            <v-btn
              small
              color="primary"
              @click="response(item)"
              v-if="item.status == 1 || item.status == 4 || item.status == 5"
              >responder</v-btn
            >
            <v-btn
              small
              color="default"
              @click="view(item)"
              v-if="item.status == 2 || item.status == 3"
              >visualizar</v-btn
            >
          </td>
        </tr>
      </tbody>
    </v-simple-table>
    <v-alert type="success" color="grey lighten-1" dense> {{ current.length }} registros encontratos</v-alert>
    <v-dialog v-model="dialog_loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Por favor aguarde
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from "../../api/index.js";
import router from "../../router/index.js";
export default {
  data: () => ({
    current: null,
    menu_de: false,
    menu_ate: false,
    dialog_loading: false,
    showFiltros: false,
    filtros: {
      operadora: 1,
      status: 1,
    },
    operadoras: [
      { text: "Vivavox", value: 1 },
      { text: "Link1000 - Cachoeira de Minas", value: 2 },
      { text: "Link1000 - Conceição dos Ouros", value: 3 },
      { text: "G2", value: 4 },
    ],
    status: [
      { text: "Aguardando", value: 1 },
      { text: "Positiva", value: 2 },
      { text: "Negativa", value: 3 },
      { text: "Vistoria", value: 4 },
      { text: "Rejeitada", value: 5 },
    ],
  }),
  created: function () {
    this.list(1);
  },
  methods: {
    openSearch: function () {
      this.showFiltros = true;
      this.current = [];
    },
    search: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .post("/viabilidade/search", this.filtros , {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao listar viabilidades!");
          console.log(error);
        });
    },
    list: function (status) {
      var me = this;
      this.showFiltros = false;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .get("/viabilidade/status/" + status, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function (response) {
          me.dialog_loading = false;
          me.current = response.data;
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao listar viabilidades!");
          console.log(error);
        });
    },
    sync: function () {
      var me = this;
      var token = localStorage.getItem("token");
      me.dialog_loading = true;
      api
        .post("/viabilidade/crm/sync", null, {
          headers: { Authorization: "Bearer " + token },
        })
        .then(function () {
          me.dialog_loading = false;
          alert("Sincronismo finalizado!");
          me.list(1);
        })
        .catch(function (error) {
          me.dialog_loading = false;
          alert("Falha ao realizar sincronismo!");
          console.log(error);
        });
    },
    response: function (item) {
      router.push({ path: `/viabilidade/${item.key}` });
    },
    view: function (item) {
      router.push({ path: `/viabilidade/open/${item.key}` });
    },
    colorStatus: function (item) {
      var color = "";
      if (item.status == 1) {
        color = "primary";
      } else if (item.status == 2) {
        color = "success";
      } else if (item.status == 3) {
        color = "error";
      } else if (item.status == 4) {
        color = "warning";
      } else if (item.status == 5) {
        color = "secondary";
      }
      return color;
    },
    formatDateInput: function (date) {
      if (!date) return null;
      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    deAlterada: function () {
      this.menu_de = false;
    },
    ateAlterada: function () {
      this.menu_ate = false;
    },
  },
  filters: {
    formatStatus: function (item) {
      var text = "";
      if (item.status == 1) {
        text = "Aguardando";
      } else if (item.status == 2) {
        text = "Positiva";
      } else if (item.status == 3) {
        text = "Negativa";
      } else if (item.status == 4) {
        text = "Vistoria";
      } else if (item.status == 5) {
        text = "Rejeitada";
      }
      return text;
    },
    formatOperadora: function (operadora) {
      var text = "";
      if (operadora == 1) {
        text = "Vivavox";
      } else if (operadora == 2) {
        text = "Link1000 - CDM";
      } else if (operadora == 3) {
        text = "Link1000 - CDO";
      } else if (operadora == 4) {
        text = "G2";
      }
      return text;
    },
    formatOrigem: function (origem) {
      var text = "";
      if (origem == 1) {
        text = "RD";
      } else if (origem == 2) {
        text = "Pipefy";
      } else if (origem == 3) {
        text = "Form";
      }
      return text;
    },
  },
  computed: {
    computedDe() {
      return this.formatDateInput(this.filtros.de);
    },
    computedAte() {
      return this.formatDateInput(this.filtros.ate);
    },
  },
};
</script>